import { render, staticRenderFns } from "./AccessWalletButton.vue?vue&type=template&id=7db8bd2e&scoped=true&functional=true&"
import script from "./AccessWalletButton.vue?vue&type=script&lang=js&"
export * from "./AccessWalletButton.vue?vue&type=script&lang=js&"
import style0 from "./AccessWalletButton.vue?vue&type=style&index=0&id=7db8bd2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "7db8bd2e",
  null
  
)

export default component.exports